import { cn } from '#/lib/utils';

import { StatsSection } from './StatsSection';

const customerStats = [
  {
    stat: '14B+',
    caption: 'consent opt-ins',
    content:
      "In 2025, our customers' users opted-in over 14 billion times with Transcend, unlocking new opportunities to activate permissioned data, deepen personalization, and drive measurable revenue lift.",
  },
  {
    stat: '1B+',
    caption: 'opt-outs',
    content:
      'Transcend also processed more than one billion opt-outs, helping our customers ensure their users’ choices were automatically captured and honored across their data architecture.',
  },
  {
    stat: '15B',
    caption: 'data rights fulfilled',
    content:
      'Our customers automatically fulfilled 15 billion user requests for do not train AI models, deletion, access, opt-outs, and more—honoring each one across every database, SaaS tool, silo, and connected system.',
  },
  {
    stat: '25M+',
    caption: 'users opted into marketing communications',
    content:
      'Through advanced preference management, Transcend digital customers massively expanded their addressable audience for email, SMS, and other direct channels, improving user experience, targeting efficiency, driving stronger engagement, and increasing ROI across their enterprises.',
  },
];

const customerStatsClassNames = {
  container: cn('bg-amethyst-04'),
  stat: cn('text-amethyst-07'),
};

export const CustomerStats = () => {
  return (
    <StatsSection
      className="bg-amethyst-08 text-cloud"
      stats={customerStats}
      statsClassNames={customerStatsClassNames}
      statsHeading={
        <>
          How our <span className="text-electric-05">customers empowered </span>{' '}
          their users this year
        </>
      }
      statsIntro="As AI adoption accelerates across the enterprise and personalization becomes a digital imperative, our customers led the way forward by giving their users seamless, transparent consent and privacy experiences, while building fully permissioned AI-ready data foundations."
    />
  );
};
